import { render, staticRenderFns } from "./districtItemData.vue?vue&type=template&id=1424ad56&scoped=true&"
import script from "./districtItemData.vue?vue&type=script&lang=js&"
export * from "./districtItemData.vue?vue&type=script&lang=js&"
import style0 from "./districtItemData.vue?vue&type=style&index=0&id=1424ad56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1424ad56",
  null
  
)

export default component.exports